"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postConstructor = void 0;
var metadata_keys_1 = require("../metadata/metadata-keys");
var error_messages_1 = require("../constants/error-messages");
var add_method_meta_1 = require("../metadata/add-method-meta");
function postConstructor() {
    return function (target, targetKey, descriptor) {
        if (typeof descriptor === 'number' || !target.constructor || !targetKey) {
            throw new Error(error_messages_1.POST_CONSTRUCTOR_DECORATOR_MISUSED);
        }
        else {
            add_method_meta_1.addMethodMeta(metadata_keys_1.POST_CONSTRUCTOR, { methodName: targetKey }, target.constructor);
        }
    };
}
exports.postConstructor = postConstructor;
//# sourceMappingURL=post-constructor-decorator.js.map